import Slider, { SliderThumb } from "@mui/material/Slider";
import { styled } from "@mui/material/styles";
import { memo } from "react";

const GainfulStyledSlider = styled(Slider)(() => ({
  color: "white",
  height: 3,
  borderRadius: 0,
  padding: "13px 0",
  "& .MuiSlider-thumb": {
    height: 40,
    width: 40,
    backgroundColor: "#333333",
    boxShadow: "none !important",
    "&:hover": {
      boxShadow: "none",
    },
    "& .gainful-bar": {
      height: 16,
      width: 2,
      backgroundColor: "white",
      marginLeft: 2,
      marginRight: 2,
    },
  },
  "& .MuiSlider-track": {
    height: 8,
    border: "1px solid #d6d6d6",
  },
  "& .MuiSlider-rail": {
    color: "white",
    opacity: 1,
    height: 8,
    border: "1px solid #d6d6d6",
  },
}));

function GainfulThumbComponent(props) {
  const { children, ...other } = props;
  return (
    <SliderThumb value={props.defaultValue} {...other}>
      {children}
      <span className="gainful-bar" />
      <span className="gainful-bar" />
      <span className="gainful-bar" />
    </SliderThumb>
  );
}

const GainfulSlider = (props) => (
  <GainfulStyledSlider
    components={{ Thumb: GainfulThumbComponent }}
    aria-label="Small"
    value={props.defaultValue}
    valueLabelDisplay="off"
    sx={{
      maxWidth: "400px",
      margin: "auto",
    }}
    // step={6}
    // min={0}
    // max={100}
    onChange={props.onChange}
  />
);

export default memo(GainfulSlider);
